export interface IFormAddUser {
  firstName: string;
  lastName: string;
  email: string;
  enabled: boolean;
  emailVerified: boolean;
  companyName?: string;
  CNPJ?: string;
  attributes: {
    BPID: string;
    INTERNAL_NAME: string;
    CNPJ: {
      companyName: string;
      CNPJ: string;
    }[];
  };
  profile: string;
}

export const INITIAL_VALUES: IFormAddUser = {
  firstName: "",
  lastName: "",
  email: "",
  enabled: true,
  emailVerified: false,
  companyName: "",
  CNPJ: "",
  attributes: {
    INTERNAL_NAME: "",
    BPID: "",
    CNPJ: [],
  },
  profile: "",
};
